import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { ButtonColor } from "@/components/Button/types";
import { Modal } from "@/components/Modals/Modal";

interface RemoveSuppressionModalProps {
	/** The stored address the confirmation names. */
	email: string;
	isRemoving: boolean;
	onConfirm: () => void;
	onClose: () => void;
}

/** The confirmation before one address leaves the Suppressed tab (PREC-4266). */
export const RemoveSuppressionModal: FunctionComponent<RemoveSuppressionModalProps> = ({
	email,
	isRemoving,
	onConfirm,
	onClose,
}) => {
	const { t } = useTranslation();

	return (
		<Modal
			handleClose={onClose}
			handleSave={onConfirm}
			isLoading={isRemoving}
			isOpened
			size="xs"
			submitButtonColor={ButtonColor.DANGER}
			submitButtonText={t("contacts.suppressed.removeAction")}
			// A yes/no question: focus moves in and stays, so Escape closes it from the row's Remove
			// button and while the disabled confirm waits on the DELETE (QA R2b, R8).
			takeFocus
			title={t("contacts.suppressed.removeTitle")}
		>
			<p data-testid="remove-suppression-confirmation">
				{t("contacts.suppressed.removeConfirmation", { email })}
			</p>
		</Modal>
	);
};
